import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  useTheme,
  alpha,
  styled,
  Card,
  CardContent,
  Slide,
} from "@mui/material";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import SavingsIcon from "@mui/icons-material/Savings";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import SpeedIcon from "@mui/icons-material/Speed";

// Ícone estilizado
const FeatureCard = styled(Card)(({ theme }) => ({
  height: "100%",
  textAlign: "center",
  padding: theme.spacing(3, 2),
  borderRadius: theme.shape.borderRadius * 1.5,
  border: `1px solid ${theme.palette.divider}`,
  transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
  "&:hover": {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 8px 20px -5px ${alpha(theme.palette.primary.main, 0.3)}`,
    transform: "translateY(-8px)",
    "& .feature-icon-wrapper": {
      backgroundColor: theme.palette.primary.main,
      transform: "scale(1.1)",
      "& svg": {
        color: theme.palette.primary.contrastText,
      },
    },
  },
}));

const FeatureIconWrapper = styled(Box)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto",
  marginBottom: theme.spacing(2.5),
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  transition: "all 0.3s ease",
  "& svg": {
    fontSize: 30,
    color: theme.palette.primary.main,
    transition: "color 0.3s ease",
  },
}));

// Array de características
const features = [
  {
    icon: <CompareArrowsIcon />,
    title: "Comparação Inteligente",
    description:
      "Analisamos seu perfil e comparamos centenas de planos para encontrar o ideal.",
    delay: 200,
  },
  {
    icon: <SavingsIcon />,
    title: "Economia Real",
    description:
      "Encontre planos até 50% mais baratos que o seu atual, mantendo a qualidade.",
    delay: 400,
  },
  {
    icon: <FactCheckIcon />,
    title: "Transparência Total",
    description:
      "Sem letras miúdas. Apresentamos todas as informações de forma clara e objetiva.",
    delay: 600,
  },
  {
    icon: <SpeedIcon />,
    title: "Processo Rápido",
    description:
      "Receba sua cotação personalizada em poucos minutos, sem burocracia.",
    delay: 800,
  },
];

export const FeaturesSection = () => {
  const theme = useTheme();

  return (
    <Box
      id="diferenciais"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
          <Typography
            variant="overline"
            sx={{
              display: "block",
              fontWeight: 600,
              color: theme.palette.secondary.main,
              mb: 1,
            }}
          >
            Nossos Diferenciais
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: "2rem", md: "2.8rem" },
              color: theme.palette.text.primary,
            }}
          >
            Facilitamos a escolha do seu plano de saúde
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Slide
                direction="up"
                in={true}
                timeout={feature.delay}
                mountOnEnter
                unmountOnExit
              >
                <FeatureCard variant="outlined">
                  <CardContent sx={{ padding: "0 !important" }}>
                    <FeatureIconWrapper className="feature-icon-wrapper">
                      {feature.icon}
                    </FeatureIconWrapper>
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 1.5,
                        color: theme.palette.text.primary,
                      }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {feature.description}
                    </Typography>
                  </CardContent>
                </FeatureCard>
              </Slide>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
